"use client";

import { CcButton } from "@/components/ui/CcButton";

import { trackAiKollenEvent } from "./ai-kollen-track";

type CcAkBookButtonProps = {
  label: string;
  /** Booking section id; Lenis scrolls smoothly to same-page anchors. */
  target: string;
  /** Where the click came from, sent with the CTA event. */
  placement: string;
  variant?: "primary" | "dark";
  className?: string;
};

/** Scroll-to-booking CTA using the site-standard expand button. */
export function CcAkBookButton({
  label,
  target,
  placement,
  variant = "primary",
  className = "",
}: CcAkBookButtonProps) {
  return (
    <CcButton
      href={`#${target}`}
      variant={variant}
      label={label}
      expand
      expandCompact
      className={className}
      onClick={() => trackAiKollenEvent("ai_kollen_cta", { placement })}
    />
  );
}
